<template>
  <div v-if="!isTraditionalPage" class="book-content" :class="{ pc: !isMobile }" @contextmenu.prevent="onMenuListShow" @click="closeMenuListShow">
    <DigitalArticleMenu
      ref="digitalArticleMenu"
      v-if="!isStaticBook & (currentEditHeader === 'catalog')"
      :width="isMobile ? '100%' : 300"
      :init-show="isShowDigitalArticleMenu"
      :init-page-index="pageIndex"
      :init-article-index="articleXiaoYangId"
      :articles="catalog"
      @onChangeArticle="onChangeArticle"
      @onClose="onCloseArticleMenu"
      :class="{ static: winEffect }"
    ></DigitalArticleMenu>
    <div
      class="turn-book-box"
      :class="{
        static: winEffect && !isStaticBook & (currentEditHeader === 'catalog'),
        'menu-show': isMenuShow,
        'article-show': isArticleShow
      }"
    >
      <img v-show="showJump" class="jump-btn" src="@imgs/left.png" @click="toPage(bookBinding === 1 ? 'next' : 'previous')" v-if="toPageBtnShow" />
      <TurnBook @onTurned="onTurned" @onTurnedXiaoYang="onTurnedXiaoYang" ref="turnBook"></TurnBook>
      <!-- <pdfview></pdfview> -->
      <img v-show="showJump" class="jump-btn" src="@imgs/right.png" @click="toPage(bookBinding === 1 ? 'previous' : 'next')" v-if="toPageBtnShow" />
    </div>
    <MenuList ref="menuList" v-if="!isMobile"></MenuList>
    <Explain ref="explain"></Explain>
    <PhoneHelp ref="phoneHelp"></PhoneHelp>
    <EpaperArticleDetail v-if="false"></EpaperArticleDetail>
    <DigitalArticleView
      :class="{ top120: isShowCommerHeader, static: winEffect }"
      v-if="!isStaticBook & (currentEditHeader === 'catalog')"
      :width="isMobile ? '100%' : '33%'"
      :init-show="isShowDigitalArticleView"
      :init-article-text="articleText"
      :init-show-prev-and-next="true"
      @onShare="onShareArticleView"
      @onClose="onCloseArticleView"
      @onPrev="onPrevArticleView"
      @onNext="onNextArticleView"
      @changeHyperlink="getXiaoYangDetailInfo"
      ref="articleView"
    ></DigitalArticleView>
    <ShareDilalog ref="shareBookMsg" :qrObj="qrObj" :current-lang="currentLang" :title="currentLang === 1 ? languageOption.sharePublication : isPaper ? '分享数字报' : '分享电子书刊'"></ShareDilalog>
  </div>
  <div v-else class="paper-turn-book-content" :class="{ pc: !isMobile }">
    <div class="paper-turn-wrapper">
      <div class="paper-turn-top">
        <PaperPage :init-page-index="pageIndex" @onTurned="onTurned" @onTurnedXiaoYang="onTurnedXiaoYang"></PaperPage>
        <Explain ref="explain"></Explain>
        <PhoneHelp ref="phoneHelphoneHelp"></PhoneHelp>
        <DigitalArticleMenu
          ref="digitalArticleMenu"
          :width="400"
          :init-show="true"
          :init-page-index="pageIndex"
          :init-article-index="articleXiaoYangId"
          :articles="catalog"
          @onChangeArticle="onChangeArticle"
          @onClose="onCloseArticleMenu"
          class="paper-turn-digital-article-menu"
        ></DigitalArticleMenu>
        <DigitalArticleView
          :width="510"
          :init-show="true"
          :init-article-text="articleText"
          :init-show-prev-and-next="false"
          @onShare="onShareArticleView"
          @onPrev="onPrevArticleView"
          @onNext="onNextArticleView"
          @changeHyperlink="getXiaoYangDetailInfo"
          ref="articleView"
          class="paper-turn-digital-article-view"
        ></DigitalArticleView>
      </div>
    </div>
    <ShareDilalog ref="shareBookMsg" :qrObj="qrObj" :current-lang="currentLang" :title="currentLang === 1 ? languageOption.sharePublication : '分享数字报'"></ShareDilalog>
    <div style="height: 200px; position: relative">
      <Thumb ref="refThumb" @changeCurrentPage="onTurned" :init-page-index="pageIndex"></Thumb>
    </div>
  </div>
</template>

<script>
import MenuList from '@components/MenuList/index.vue'
import TurnBook from './turnBook.vue'
import { formatDigitalArticle } from '@/utils'
// import Pdfview from '@components/pdfview/pdfview'
import getBook from '@api/getBook'
import Explain from '@components/books/components/Help.vue'
import PhoneHelp from '@components/books/components/PhoneHelp.vue'
import ShareDilalog from '@/components/books/components/ShareDialog'
import EpaperArticleDetail from './components/EpaperArticleDetail.vue'
import mixin from './turnBookMixin'
import Thumb from './paper-turn/Thumb'
import PaperPage from './paper-turn/paperPage'
import DigitalArticleView from '../digital/DigitalArticleView' // 小样
import DigitalArticleMenu from '../digital/DigitalArticleMenu' // 目录
import { mapState } from 'vuex'
export default {
  name: 'bookContent',
  mixins: [mixin],
  data() {
    return {
      timer: '',
      articles: [],
      catalog: [],
      pageIndex: 1,
      articleIndex: 0,
      articleXiaoYangId: 0,
      articleTitle: '',
      articleText: '',
      openDigitalArticleMobile: true,
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0
      },
      hyperlinkid: '',
      epaperId: this.$route.query.id
    }
  },
  computed: {
    ...mapState('book', ['totalPage', 'bookData', 'isListenAndRead']),
    isMobile() {
      return this.$store.state.book.isMobile
    },
    voiceNumber() {
      return this.$store.state.config.bookObj.voiceNumber
    },
    bookBinding() {
      return this.$store.state.config.bookObj.bookBinding
    },
    isEditDrawerShow() {
      return this.$store.state.edit.isEditDrawerShow
    },
    isStaticBook() {
      return this.$store.state.common.isStaticBook
    },
    currentEditHeader() {
      return this.$store.state.edit.currentEditHeader
    },
    bookPath() {
      return this.$store.state.book.bookPath
    },
    toPageBtnShow() {
      const result = !this.isMobile
      return result
    },
    showJump() {
      let bookContent = $('#app')
      return bookContent.width() / (bookContent.height() - 80) > 1.4 && this.$store.state.config.bookObj.displayOrNot.bothSidePageBtn !== 0
    },
    isShowDigitalArticleMenu() {
      return this.$store.state.book.isShowDigitalArticleMenu
    },
    digitalArticleId() {
      return this.$store.state.book.digitalArticleId
    },
    isShowCommerHeader() {
      return this.$route.meta.requiresAuth === true && this.$store.state.book.isShowCommerHeader && !this.$store.state.common.isStaticBook
    },
    isShowDigitalArticleView() {
      return this.$store.state.book.isShowDigitalArticleView
    },
    isTraditionalPage() {
      return this.isPaper && this.bookData.style === 1 && !this.isMobile
    },
    languageOption() {
      return this.$store.state.config.languageOptions[this.currentLang]
    },
    currentLang() {
      return this.$store.state.config.bookObj.language
    },
    menuListVisible() {
      console.log(777)
      return this.$store.state.config.bookObj.displayOrNot.rightKeyMenu !== 0
    },
    winEffect() {
      return this.$store.state.config.bookObj.winEffect
    },
    isMenuShow() {
      return this.isShowDigitalArticleMenu || (!this.isPaper && this.isEditDrawerShow && this.currentEditHeader === 'catalog')
    },
    isArticleShow() {
      return this.isShowDigitalArticleView && this.currentEditHeader === 'catalog'
    }
  },
  components: {
    DigitalArticleMenu,
    DigitalArticleView,
    TurnBook,
    // Pdfview,
    MenuList,
    Explain,
    PhoneHelp,
    EpaperArticleDetail,
    Thumb,
    PaperPage,
    ShareDilalog
  },
  mounted() {
    this.init()
  },
  watch: {
    digitalArticleId(val) {
      if (val && !this.isPaper && !this.isMobile) {
        this.getXiaoYangDetailInfo(val)
      }
    },
    isListenAndRead(val, oldVal) {
      console.log('isListenAndRead', val, oldVal)
      if (oldVal) {
        return
      }
      if (val) {
        let currentPageNum = this.currentPageArray[0] || 1
        let maxPageNum = this.totalPage
        let article
        while (currentPageNum <= maxPageNum) {
          article = this.articles.find((item) => item.page === currentPageNum)
          while (article && !article.xiaoYangId && article.children && article.children.length) {
            article = article.children[0]
          }
          if (!article || !article.xiaoYangId) {
            currentPageNum++
          } else {
            break
          }
          if (currentPageNum > maxPageNum) {
            currentPageNum = 1
          }
          if ((this.currentPageArray[0] || 1) === currentPageNum) {
            return
          }
        }
        if (this.openDigitalArticleMobile && this.isMobile) {
          // 微信下则跳转至新的页面
          this.$router.push({ name: 'digitalArticleMobile', query: { id: article.xiaoYangId, type: this.isPaper ? 'paper' : 'book', from: 'content', albumId: this.$route.query.shelfId } })
          return
        }
        if (this.articleXiaoYangId === article.xiaoYangId) {
          this.$nextTick(() => {
            this.$refs.articleView.read()
          })
        } else {
          this.getXiaoYangDetailInfo(article.xiaoYangId)
        }
        if (this.currentPageArray.includes(currentPageNum)) {
          this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', true)
        } else {
          $('#book').turn('page', article.page)
        }
      }
    },
    isMenuShow() {
      this.handleBoxSizeChange()
    },
    isArticleShow() {
      this.handleBoxSizeChange()
    }
  },
  methods: {
    handleBoxSizeChange() {
      if (this.winEffect) {
        window.onresize()
      }
    },
    getArticleIdsFromCatalog(catalog) {
      let res = []
      catalog.forEach((item) => {
        if (item.xiaoYangId) {
          res.push(item)
        }
        if (item.children) {
          res = res.concat(this.getArticleIdsFromCatalog(item.children))
        }
      })
      return res
    },
    init() {
      if (this.bookData === null) {
        setTimeout(() => {
          this.init()
        }, 1000)
        return
      }
      // 从缓存中读取上一次的阅读的页数
      this.readingLog = JSON.parse(localStorage.getItem('readingLog')) || {}
      this.pageIndex = this.readingLog[this.$route.query.id] || 1
      if (this.$route.query.page) {
        this.pageIndex = parseInt(this.$route.query.page)
        this.$store.commit('book/UPDATE_CURRENT_PAGE', [this.pageIndex])
      }
      // 数字报获取小样目录
      // 导览文章列表
      if (this.bookData.catalog) {
        let catalog = JSON.parse(this.bookData.catalog)
        let articles = (catalog ? this.processCatalogList(catalog.catalogList, this.bookData.displayPageNo) : []) || []
        this.catalog = articles
        this.articles = this.getArticleIdsFromCatalog(articles)
        console.log(this.articles)
      } else {
        this.articles = []
        this.catalog = []
      }
      console.log(this.articles)

      if (this.articles.length === 0) {
        this.isShowTab = false
      }
      this.getXiaoYangDetailInfo(this.getFirstArticleXiaoYangId(this.pageIndex))
      // 移动端时，如果存在目录之前是打开状态，则进入页面后尝试恢复目录之前的展示状态
      if (this.openDigitalArticleMobile && this.isMobile) {
        let isShowDigitalArticleMenu = sessionStorage.getItem('isShowDigitalArticleMenu_' + this.$route.query.id)
        let isShowDigitalArticleMenu_articleIndex = sessionStorage.getItem('isShowDigitalArticleMenu_articleIndex')
        if (isShowDigitalArticleMenu === 'true') {
          if (isShowDigitalArticleMenu_articleIndex) {
            for (let i = 0; i < this.articles.length; i++) {
              if (this.articles[i].xiaoYangid == isShowDigitalArticleMenu_articleIndex) {
                this.articleIndex = i
                break
              }
            }
          }
          this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_MENU', true)
          setTimeout(() => {
            let menuBox = this.$refs.digitalArticleMenu.$el.getElementsByClassName('box')[0]
            let menuItems = this.$refs.digitalArticleMenu.$el.getElementsByClassName('item')
            for (let a in menuItems) {
              if (menuItems.hasOwnProperty(a) && parseInt(this.pageIndex) === parseInt(a) + 1) {
                menuBox.scrollTop = menuItems[a].offsetTop
              }
            }
          }, 100)
        }
      }
    },
    shareBook(link, poster, posterPic, title) {
      this.$refs.shareBookMsg.dialogVisible = true
      this.$store.commit('config/UPDATE_POSTERBG', posterPic)
      this.$store.commit('config/UPDATE_POSTER', poster)
      this.qrObj.value = link
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.isShowPoster = poster
      this.qrObj.title = title
    },
    // 书刊部分展示时，删除冗余页码目录
    processCatalogList(catalog, displayPageNo) {
      if (displayPageNo === 0 || !catalog) {
        return catalog
      }

      function deleteNode(arr) {
        let list = arr
        for (let i = 0; i < list.length; ) {
          if (list[i].page > displayPageNo) {
            list.splice(i, 1)
          } else if (list[i].children && list[i].children.length > 0) {
            deleteNode(list[i].children)
            i++
          } else {
            i++
          }
        }
      }

      deleteNode(catalog)
      return catalog
    },
    /**
     * 获取书箱明细数据
     * @param params
     * @param callback
     */
    getBookDetails(params, callback) {
      let url = this.isPaper ? getBook.GetPaperDetails : getBook.GetMobileBookDetails
      url(params).then((res) => {
        if (res && res.data && res.status === 200) {
          callback(res.data.data)
        }
      })
    },
    getFirstArticleXiaoYangId(pageIndex) {
      if (this.catalog[pageIndex - 1]?.children && this.isPaper && this.bookData?.readModel === 2) {
        //zip数字报可以直接从目录取小样id
        return this.catalog[pageIndex - 1]?.children[0]?.xiaoYangId
      } else if (this.bookData.pages && this.bookData.pages[pageIndex - 1] && this.bookData.pages[pageIndex - 1].coordinates && this.bookData.pages[pageIndex - 1].coordinates.length > 0) {
        //手动添加的文章从热区列表中获取小样id
        this.articleIndex = null
        return this.bookData.pages[pageIndex - 1].coordinates[0].xiaoyangid
      } else if (this.articles[this.articleIndex]) {
        return this.articles[this.articleIndex].xiaoYangId
      } else {
        return 0
      }
    },
    getXiaoYangDetail(xiaoYangId, callback) {
      // 根据小样ID获取内容详情
      const params = {
        id: xiaoYangId,
        sentenceRead: this.bookData.sentenceRead
      }
      getBook.getXiaoYangDetail(params).then((res) => {
        if (res && res.data && res.status === 200 && res.data.status === 0) {
          callback && callback(formatDigitalArticle(res).data.data)
        } else {
          callback && callback({ title: '', content: '' })
        }
      })
    },
    getXiaoYangDetailInfo(xiaoYangId, articleIndex) {
      if (xiaoYangId) {
        if (!articleIndex && articleIndex !== 0) {
          //更新小样顺序索引
          for (let i = 0; i < this.articles.length; i++) {
            if (this.articles[i]?.xiaoYangId === xiaoYangId) {
              this.articleIndex = i
              this.pageIndex = this.articles[i].page
              break
            }
          }
        }
        this.getXiaoYangDetail(xiaoYangId, (data) => {
          this.articleXiaoYangId = xiaoYangId
          this.articleTitle = data.title
          this.articleText = data.content
          this.$refs.articleView.articleId = this.articleXiaoYangId
          this.$refs.articleView.title = data.title
          this.$refs.articleView.creator = data.creator
          this.$refs.articleView.edition = data.pageNo
        })
      }
    },
    repairAlert() {
      // 移动端时需要修复一下弹窗的层级问题
      if (this.isMobile) {
        setTimeout(() => {
          for (let a in document.body.children) {
            if (document.body.children.hasOwnProperty(a)) {
              let tabindex = parseInt(document.body.children[a].getAttribute('tabindex'))
              let className = document.body.children[a].className
              if (className.indexOf('el-message-box__wrapper') >= 0 && tabindex === -1) {
                document.body.children[a].style.zIndex = 10000
              } else if (className.indexOf('v-modal') >= 0 && tabindex === 0) {
                document.body.children[a].style.zIndex = 9999
              }
            }
          }
        }, 100)
      }
    },
    // 左键菜单框消失
    closeMenuListShow() {
      if (!this.isMobile) {
        this.$refs.menuList.isMenuShow = false
      }
    },
    //点击书刊区域鼠标右键菜单修改为> “放大”“缩小”“全屏”快捷操作父元素显示
    onMenuListShow(ev) {
      console.log(11)
      if (!this.menuListVisible) {
        return
      }
      let MenuLists = this.$refs.menuList
      if (MenuLists) {
        MenuLists.isMenuShow = !MenuLists.isMenuShow
        var oEvent = ev
        let pxs1 = oEvent.clientX + 'px'
        let pxs2 = oEvent.clientY - 122 + 'px'
        this.$nextTick(() => {
          $('.menu-list').css({ left: `${pxs1}` })
          $('.menu-list').css({ top: `${pxs2}` })
        })
      }
    },
    onChangeArticle(page, article, pageIndex, optype) {
      this.pageIndex = pageIndex
      if (!this.isTraditionalPage) {
        //翻页样式使用翻页插件
        if (this.isSwiper) {
          window.mySwiper.slideTo(pageIndex - 1)
        } else {
          $('#book').turn('page', pageIndex)
        }
      } else {
        //传统样式翻页
        this.$store.commit('book/UPDATE_CURRENT_PAGE', [pageIndex])
      }
      if (optype === 1) {
        if (this.isMobile) {
          this.onCloseArticleMenu()
        }
      } else if (optype === 2) {
        if (article && article.xiaoYangId) {
          if (this.openDigitalArticleMobile && this.isMobile) {
            // 如果是移动端，则保存一下文章的索引
            sessionStorage.setItem('isShowDigitalArticleMenu_articleIndex', article.xiaoYangId)
            // 微信下则跳转至新的页面
            this.$router.push({ name: 'digitalArticleMobile', query: { id: article.xiaoYangId, type: this.isPaper ? 'paper' : 'book', from: 'content', albumId: this.$route.query.shelfId } })
          } else {
            this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', true)
            this.getXiaoYangDetailInfo(article.xiaoYangId)
          }
        }
      }
    },
    onCloseArticleMenu() {
      this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_MENU', !this.isShowDigitalArticleMenu)
      this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', this.isShowDigitalArticleMenu || this.isShowDigitalArticleView)
      if (this.openDigitalArticleMobile && this.isMobile) {
        // 如果是移动端，则保存一下目录的打开状态
        sessionStorage.setItem('isShowDigitalArticleMenu_' + this.$route.query.id, this.isShowDigitalArticleMenu)
      }
    },
    onShareArticleView() {
      this.shareBook(
        window.location.origin + '/elecPublish/digitalArticleMobile?id=' + this.articleXiaoYangId + '&voiceNumber=' + this.voiceNumber + '&type=' + (!this.isPaper ? 'book' : 'paper'),
        '',
        '',
        this.articleTitle
      )
    },
    onCloseArticleView() {
      this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', !this.isShowDigitalArticleView)
    },
    onPrevArticleView() {
      if (this.articleIndex === 0) {
        this.$alert(this.currentLang === 1 ? 'This is the first article' : '已经是第一篇文章', this.languageOption.notice, {
          confirmButtonText: this.languageOption.confirm
        })
        this.repairAlert()
        return
      }
      let articleIndex = this.articleIndex - 1
      let xiaoYangId = this.articles[articleIndex]?.xiaoYangId || 0
      if (xiaoYangId === 0) {
        return
      }
      this.pageIndex = this.articles[articleIndex].page
      if (!this.isTraditionalPage) {
        //翻页样式使用翻页插件
        if (this.isSwiper) {
          window.mySwiper.slideTo(this.pageIndex - 1)
        } else {
          $('#book').turn('page', this.pageIndex)
        }
      } else {
        //传统样式翻页
        this.$store.commit('book/UPDATE_CURRENT_PAGE', [this.pageIndex])
      }
      this.articleIndex = articleIndex
      this.getXiaoYangDetailInfo(xiaoYangId, articleIndex)
    },
    onNextArticleView() {
      if (this.articleIndex >= this.articles.length - 1) {
        this.$alert(this.currentLang === 1 ? 'This is the last article' : '已经是最后一篇文章', this.languageOption.notice, {
          confirmButtonText: this.languageOption.confirm
        })
        if (this.isListenAndRead) {
          this.$store.commit('book/UPDATE_IS_LISTEN_AND_READ', false)
        }
        this.repairAlert()
        return
      }
      let articleIndex = this.articleIndex + 1
      let xiaoYangId = this.articles[articleIndex].xiaoYangId || 0
      if (xiaoYangId === 0) {
        return
      }
      this.pageIndex = this.articles[articleIndex].page
      if (!this.isTraditionalPage) {
        //翻页样式使用翻页插件
        if (this.isSwiper) {
          window.mySwiper.slideTo(this.pageIndex - 1)
        } else {
          $('#book').turn('page', this.pageIndex)
        }
      } else {
        //传统样式翻页
        this.$store.commit('book/UPDATE_CURRENT_PAGE', [this.pageIndex])
      }
      this.articleIndex = articleIndex
      this.getXiaoYangDetailInfo(xiaoYangId, articleIndex)
    },
    onTurned(page) {
      if (this.isListenAndRead) {
        this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', true)
      }
      if (this.pageIndex === this.$store.state.book.currentPage[0] || this.pageIndex === this.$store.state.book.currentPage[1]) {
        return
      }
      this.pageIndex = page
      this.getXiaoYangDetailInfo(this.getFirstArticleXiaoYangId(page))
    },
    onTurnedXiaoYang(coordinate, page) {
      if (this.openDigitalArticleMobile && this.isMobile) {
        // 微信下则跳转至新的页面
        this.$router.push({ name: 'digitalArticleMobile', query: { id: coordinate.xiaoyangid, type: this.isPaper ? 'paper' : 'book', from: 'content', albumId: this.$route.query.shelfId } })
      } else {
        this.pageIndex = page.index
        this.getXiaoYangDetailInfo(coordinate.xiaoyangid)
        this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', true)
        // this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', this.isShowDigitalArticleMenu || this.isShowDigitalArticleView)
      }
    }
  }
}
</script>
<style lang="scss">
.book-content {
  padding: 40px 0;
  position: relative;
  &.pc {
    z-index: 1;
    padding-right: 5px;
    padding-left: 5px;
    &.width67 {
      width: 67%;
    }
  }
  .turn-book-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    &.static {
      &.menu-show {
        margin-left: 300px;
        width: calc(100% - 300px);
      }
      &.article-show {
        margin-right: 33%;
        width: calc(67% - 5px);
      }
    }
  }
  .turn-book-box.static.menu-show.article-show {
    width: calc(67% - 305px);
  }
  .digital-article-view {
    position: fixed;
    top: 40px;
    height: calc(100% - 40px);
    padding-bottom: 40px;
    &.top120 {
      top: 120px;
      height: calc(100% - 120px);
    }
    .login {
      display: none;
    }
    .collect {
      right: 90px;
      top: 0;
      margin-top: 12px;
    }
  }
  img {
    z-index: 1;
  }
  .jump-btn {
    cursor: pointer;
    width: 42px;
  }
}
</style>
<style lang="scss">
.paper-turn-book-content {
  height: 100%;
  width: 100%;
  .paper-turn-wrapper {
    display: flex;
    justify-content: center;
    padding: 30px 0;
  }
  .paper-turn-top {
    display: flex;
    height: 83%;
    overflow-x: auto;
    overflow-y: hidden;
  }
  &.pc {
    &.width67 {
      width: 67%;
    }
  }
  img {
    z-index: 1;
  }
  .jump-btn {
    cursor: pointer;
  }

  .el-drawer__wrapper {
    position: static !important;
    height: 200px;
  }
}
</style>
